import { Helmet } from "react-helmet-async";

const toAbsoluteUrl = (baseUrl, url) => {
  if (!url) return baseUrl;
  if (/^https?:\/\//i.test(url)) return url;
  return `${baseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
};

export const SEOHead = ({
  title,
  description,
  url,
  image,
  type = "website",
  jsonLd,
}) => {
  const baseUrl =
    process.env.REACT_APP_FRONTEND_URL || window.location.origin;
  const canonicalUrl = toAbsoluteUrl(baseUrl, url);
  const ogImage = toAbsoluteUrl(baseUrl, image || "/favicon-512.png");
  const jsonLdItems = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="OneGrad" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {jsonLdItems.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};
